import useDataverseService from "../../services/DataverseService";
import { useData } from "../Contexts/DataProvider";
import { useRibbon } from "../Contexts/RibbonProvider";
import { useSelectedRows } from "../Contexts/SelectedRowsProvider";
import { useSelectedTab } from "../Contexts/SelectedTabProvider";

export const useAssignment = () => {
  const { selectedTab } = useSelectedTab();
  const dataverseService = useDataverseService();
  const { data, setData } = useData();
  const { selectedRows } = useSelectedRows();
  const { addRibbon } = useRibbon();

  const assignUser = async (
    user: any,
    allRecordsSelected: boolean,
    setLoading: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    setLoading(true);
    const systemUserId = user.systemuserid;
    const assignedItemIds: string[] = [];

    if (!data || !Array.isArray(data.value)) {
      addRibbon("No data available for assignment.", "error");
      return;
    }

    const getAllSelectedRowIds = (selectedRows: any[]): string[] => {
      if (!Array.isArray(selectedRows)) return [];
      return selectedRows.flatMap((sr: any) =>
        Array.isArray(sr.rows) ? sr.rows.map((r: any) => r.id) : []
      );
    };

    let rowsToAssign: any[] = [];
    const dataset = selectedTab === "Budget" ? data.value : data.headCount;
    if (
      !allRecordsSelected &&
      Array.isArray(selectedRows) &&
      selectedRows.length > 0
    ) {
      const allSelectedIds = getAllSelectedRowIds(selectedRows);
      rowsToAssign = dataset.filter(
        (item: any) =>
          allSelectedIds.includes(item.cr864_budgetrecordid) ||
          allSelectedIds.includes(item.new_headcountid)
      );
    } else if (allRecordsSelected) {
      rowsToAssign = [...dataset];
    }

    let error = false;

    let entitySetName;
    if (selectedTab === "Budget") {
      entitySetName = "cr864_budgetrecords";
    } else if (selectedTab === "FTE") {
      entitySetName = "new_headcounts";
    } else {
      entitySetName = "";
    }

    for (const row of rowsToAssign) {
      try {
        await dataverseService.associateRecord(
          entitySetName,
          selectedTab === "Budget"
            ? row.cr864_budgetrecordid
            : row.new_headcountid,
          "systemusers",
          systemUserId
        );
        row._ownerid_value = systemUserId;
        assignedItemIds.push(
          selectedTab === "Budget"
            ? row.cr864_budgetrecordid
            : row.new_headcountid
        );
      } catch (e) {
        setLoading(false);

        addRibbon(
          `"Prosim, o pridelenie pristupu do HR Budgeting app pre ${user.internalemailaddress}`,
          "error"
        );
        error = true;
      }
    }

    if (!error) {
      const newValue = data.value.filter((item: any) => {
        const itemId = item.cr864_budgetrecordid;
        return !assignedItemIds.includes(itemId);
      });
      const newHeadCount = data.headCount.filter((item: any) => {
        const itemId = item.new_headcountid;
        return !assignedItemIds.includes(itemId);
      });

      setData({ ...data, value: newValue, headCount: newHeadCount });

      setLoading(false);

      addRibbon("Your assignment was completed successfully.", "info");
    }
  };

  return { assignUser };
};
